import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import {
  BackButton,
  EmployeeAssignmentForm,
  Error,
  Loading,
  LoadingDialog,
  SocketIOLoading,
  ViewTitle,
} from '@iarc-programing/emanufac-components/src/components';
import { MQ_TASK } from '@iarc-programing/emanufac-constant';
import MANUFACTURING_TRANSACTION_TYPE from '@iarc-programing/emanufac-constant/manufacturingTxnType.constant';
import { Button, Card, CardContent } from '@mui/material';
import { gql } from 'graphql-request';
import _ from 'lodash';
import hash from 'object-hash';
import PropTypes from 'prop-types';
import Swal from 'sweetalert2';

import { config } from '@/configs';
import graphqlClient from '@/configs/graphqlClient';
import * as actions from '@/redux/actions';
/**
 * @function ProcessAssignment
 * @description Display a collections or a list of ProcessAssignment from database
 */

export default function ProcessAssignment({ title, subtitle }) {
  const dispatch = useDispatch();
  const currentProcess = useSelector((state) => state.process);
  const employee = useSelector((state) => state.employee);
  const department = useSelector((state) => state.department);
  const measurementType = useSelector((state) => state.measurementType);
  const resultingFunctionType = useSelector(
    (state) => state.resultingFunctionType,
  );
  const information = useSelector((state) => state.information);
  const shippingRound = useSelector((state) => state.shippingRound);
  const shippingType = useSelector((state) => state.shippingType);
  const me = useSelector((state) => state.me);

  const history = useHistory();
  const params = useParams();
  const [referenceNumber, setReferenceNumber] = useState();
  const [isDialogLoadingOn, setIsDialogLoadingOn] = useState(false);

  const { control, handleSubmit, setValue, watch } = useForm({
    defaultValues: {
      steps: _.isEmpty(currentProcess?.steps)
        ? _.orderBy(
            _.map(currentProcess?.product?.steps, (_step) => ({
              ..._step,
              _id: undefined,
            })),
            ['index'],
            ['asc'],
          )
        : _.orderBy(currentProcess?.steps, ['index'], ['asc']),
    },
  });

  // ถ้าหากมีค่าใน Step อยู่แล้ว ให้ยึดตามนั้นเป็นหลัก ถ้าไม่มีจึงไปดูใน Product step
  useEffect(() => {
    if (_.isEmpty(currentProcess?.steps)) {
      setValue(
        'steps',
        _.orderBy(
          _.map(currentProcess?.product?.steps, (_step) => ({
            ..._step,
            _id: undefined,
          })),
          ['index'],
          ['asc'],
        ),
      );
    } else {
      setValue('steps', _.orderBy(currentProcess?.steps, ['index'], ['asc']));
    }
    setValue('delivery', currentProcess?.delivery);

    return () => {};
  }, [currentProcess]);

  const query = gql`
    query FindProcess(
      $processInput: ProcessInput
      $employeeInput: EmployeeInput
      $depertmentInput: DepartmentInput
      $measurementTypeInput: MeasurementTypeInput
      $resultingFunctionTypeInput: ResultingFunctionTypeInput
    ) {
      findOneProcess(input: $processInput) {
        _id
        current {
          index
          step {
            _id
            name
          }
        }
        product {
          steps {
            name
            index
            responsible {
              department {
                _id
                name
              }
            }
          }
        }
        steps {
          _id
          name
          index
          responsible {
            employee {
              _id
              firstname
              lastname
              image {
                url
              }
            }
            department {
              _id
              name
            }
          }
          material_associate
          measurements {
            _id
            measurement_type {
              _id
              name
            }
          }
          resultingFunctionTypes {
            _id
            name
          }
          completed
          deleted
          is_delivery_step
        }
        delivery {
          shipping_round {
            _id
            name
          }
          delivery_method {
            _id
            name
          }
          delivery_remark
          delivery_date
        }
      }
      findEmployees(input: $employeeInput) {
        total
        rows {
          _id
          firstname
          lastname
          image {
            url
          }
        }
      }
      findDepartments(input: $depertmentInput) {
        total
        rows {
          _id
          name
        }
      }
      findMeasurementTypes(input: $measurementTypeInput) {
        total
        rows {
          _id
          name
        }
      }
      findResultingFunctionTypes(input: $resultingFunctionTypeInput) {
        total
        rows {
          _id
          name
        }
      }
    }
  `;

  useEffect(() => {
    const refNo = hash({
      date: new Date(),
      user: me?.userData?._id,
    });

    setReferenceNumber(refNo);

    return () => {};
  }, []);

  const getShippingRoundAndType = async () => {
    try {
      dispatch(
        actions.shippingRoundAll({
          page: 1,
          size: config.maxFetchSize,
        }),
      );
      dispatch(
        actions.shippingTypeAll({
          page: 1,
          size: config.maxFetchSize,
        }),
      );
    } catch (error) {
      alert(`ไม่สามารถดึงข้อมูลการจัดส่งได้ ${error?.message}`);
    }
  };

  const queryDataFromServer = async () => {
    try {
      const queryResult = await graphqlClient.request(query, {
        processInput: {
          id: params.id,
          fetchCurrentStep: true,
          fetchInsideProcess: true,
        },
        employeeInput: {
          page: 1,
          size: config.maxFetchSize,
        },
        departmentInput: {
          page: 1,
          size: config.maxFetchSize,
        },
        resultingFunctionTypeInput: {
          page: 1,
          size: config.maxFetchSize,
        },
        measurementTypeInput: {
          page: 1,
          size: config.maxFetchSize,
        },
      });
      const processData = queryResult?.findOneProcess;
      const employeeData = queryResult?.findEmployees;
      const departmentData = queryResult.findDepartments;
      const measurementTypeData = queryResult?.findMeasurementTypes;
      const resultingFunctionTypeData = queryResult?.findResultingFunctionTypes;
      dispatch(actions.processStateOneSet(processData));
      dispatch(actions.employeeStateSet(employeeData));
      dispatch(actions.departmentStateSet(departmentData));
      dispatch(actions.measurementTypeStateSet(measurementTypeData));
      dispatch(
        actions.resultingFunctionTypeStateSet(resultingFunctionTypeData),
      );
    } catch (error) {
      alert('เกิดข้อผิดพลาดในการดึงข้อมูล ');
      console.error('Error on Query', error);
    }
  };

  useEffect(() => {
    queryDataFromServer();
    getShippingRoundAndType();
    return () => {};
  }, [params]);

  const onSubmit = async (assignmentSteps) => {
    try {
      const flattenAssignmentArray = _.map(
        assignmentSteps?.steps,
        (_step, index) => ({
          ..._step,
          index,
          responsible: {
            employee: _step?.responsible?.employee?._id,
            employeeName: _step?.responsible?.employee?.firstname || '',
            department: _step?.responsible?.department?._id,
            departmentName: _step?.responsible?.department?.name || '',
          },
        }),
      );
      console.log('Assignment Array', flattenAssignmentArray);
      setIsDialogLoadingOn(true);
      console.log('Assignment Array', flattenAssignmentArray);
      Swal.fire({
        title: 'ยืนยันการมอบหมายงาน',
        showCancelButton: true,
        icon: 'warning',
        html: `
                <div>
                การมอบหมายงานของคุณคือ
                ${_.map(
                  flattenAssignmentArray,
                  (step) => `<div>
                ขั้นตอนที่ ${step?.index + 1} : ${step?.name} - แผนก ${
                    step?.responsible?.departmentName
                  } - พนักงาน ${step?.responsible?.employeeName} 
                </div>`,
                )}
                </div>
                `,
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
      }).then(async (result) => {
        if (result.isConfirmed) {
          await dispatch(
            actions.processPut(currentProcess?._id, {
              assignments: flattenAssignmentArray,
              employeeId: me?.userData?._id,
              manufacturing_transaction_type:
                MANUFACTURING_TRANSACTION_TYPE.PROCESS_UPDATE.status_code,
              delivery: assignmentSteps?.delivery,
              referenceNumber,
            }),
          );
        }
      });
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'ไม่สามารถสร้างแก้ไขการมอบหมายงานได้',
        text: error?.message,
      });
    }
  };

  const handleSocketIOFunction = {
    onFail: (args) => {
      setIsDialogLoadingOn(false);
      Swal.fire({
        icon: 'error',
        title: 'ไม่สามารถสร้างแก้ไขการมอบหมายงานได้',
        text: args?.message,
      });
    },
    onSuccess: (args) => {
      setIsDialogLoadingOn(false);
      Swal.fire({
        icon: 'success',
        title: 'ดำเนินการสำเร็จแล้ว',
        text: 'แก้ไขการมอบหมายงานสำเร็จ',
      });
      history.goBack();
    },
  };

  const renderTitle = () => <ViewTitle title={title} subtitle={subtitle} />;

  if (currentProcess.isLoading) {
    return <Loading />;
  }

  if (!currentProcess.isLoading && currentProcess.isCompleted) {
    return (
      <div>
        {renderTitle()}
        <SocketIOLoading
          referenceNumber={referenceNumber}
          taskCode={MQ_TASK.UPDATE_PROCESS.status_code}
          handleFail={handleSocketIOFunction.onFail}
          handleSuccess={handleSocketIOFunction.onSuccess}
          setStatusMessage={() => {}}
        />
        <LoadingDialog
          isLoading={isDialogLoadingOn}
          label="กำลังอัพเดทข้อมูล"
        />
        <div>
          <BackButton />
        </div>
        <div className="my-2">
          <Card>
            <CardContent>
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="flex gap-2 justify-between">
                  <h3 className="text-lg font-semibold">แจกจ่ายงาน</h3>
                </div>
                <div
                  className="overflow-y-auto "
                  style={{ maxHeight: '760px' }}
                >
                  <EmployeeAssignmentForm
                    control={control}
                    employee={employee}
                    department={department}
                    steps={currentProcess?.steps}
                    measurementType={measurementType}
                    setValue={setValue}
                    watch={watch}
                    resultingFunctionTypes={resultingFunctionType}
                    shippingRound={shippingRound}
                    shippingType={shippingType}
                  />
                </div>
                <div className="flex justify-end">
                  <Button variant="contained" color="success" type="submit">
                    มอบหมายงาน
                  </Button>
                </div>
              </form>
            </CardContent>
          </Card>
        </div>
      </div>
    );
  }
  return <Error />;
}

ProcessAssignment.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

ProcessAssignment.defaultProps = {
  title: '',
  subtitle: '',
};
